import ImmunizationResult from '../../model/immunizationResult'
import mapUser from './userMapper'
import moment from 'moment';

/*
    {
        "vaccinationDate": "2021-07-07",
        "tradeName": "COVID-19 Moderna mRNA-ARNm-1273 MT",
        "agentName": "COVID-19 mRNA",
        "lotNumber": "COV-MOD-12345",
        "lotExpiryDate": "2030-12-31",
        "dosage": 0.5,
        "dosageUOM": "mL",
        "site": "Buttock",
        "route": "Infiltrate",
        "serviceLocation": "Bathurst High School",
        "serviceProvider": "Alexa Smith"
    },
*/
export function mapImmunizationResults(data) {
    const results = data.immunizations.map(i => {
        const date = moment(i.vaccinationDate).format("YYYY-MM-DD");
        return new ImmunizationResult(i.tradeName, i.agentName, date, i.serviceLocation)
    })

    const user = mapUser(data);

    // Sort results by date..
    let sortedResults = results.sort(function(a, b) {
        return b.immunizationDate - a.immunizationDate;
    });
    return { user, sortedResults };
}
